"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getI18nTTDomain: ()=>getI18nTTDomain,
    getCurrentDomainIDOption: ()=>getCurrentDomainIDOption
});
const external_tool_js_namespaceObject = require("../tool.js");
const external_domain_id_polyfill_js_namespaceObject = require("./domain-id.polyfill.js");
const getCurrentDomainIDOption = function(options) {
    let domainID = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (0, external_tool_js_namespaceObject.tryCatch)(external_domain_id_polyfill_js_namespaceObject.getCurrentDomainID, (error)=>{
        console.error({
            message: null == error ? void 0 : error.message,
            position: 'getCurrentDomainIDOption',
            context: {
                currentDomainID: external_domain_id_polyfill_js_namespaceObject.currentDomainID
            }
        });
        throw error;
    });
    const result = options[domainID];
    if (void 0 !== result) return result;
    throw new external_tool_js_namespaceObject.CommonLibError('getCurrentDomainIDOption', `option in current domainID ${domainID} is not exist`);
};
const getI18nTTDomain = ()=>{
    var _window_getBytecloudContext, _window, _context_getI18nTTDomain;
    const module = window.location.pathname.split('/')[1] || 'unknown';
    const context = null == (_window_getBytecloudContext = (_window = window).getBytecloudContext) ? void 0 : _window_getBytecloudContext.call(_window, module);
    const domain = null == context ? void 0 : null == (_context_getI18nTTDomain = context.getI18nTTDomain) ? void 0 : _context_getI18nTTDomain.call(context);
    return domain ? domain : 'cloud-i18n.bytedance.net';
};
exports.getCurrentDomainIDOption = __webpack_exports__.getCurrentDomainIDOption;
exports.getI18nTTDomain = __webpack_exports__.getI18nTTDomain;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getCurrentDomainIDOption",
    "getI18nTTDomain"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
